<template>
  <div id="app" >

    <notification />

    <navigation-bar v-if="loggedIn" />

    <div id="content" class="container">
      <router-view />
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Notification from 'components/Notification'
import NavigationBar from 'components/NavigationBar'

export default {
  components: { NavigationBar, Notification },
  computed: {
    ...mapGetters(['loggedIn'])
  }
}
</script>

<style>
#content {
  padding: 25px 3% 0;
  padding-top: 85px;
}
</style>


// WEBPACK FOOTER //
// App.vue?18a1af24